<template>
  <div class="footer tc">
    <div class="fs16">联系方式</div>
    <div style="margin: 30px auto; width: 500px">
      <div class="bc" flex="cross:center main:justify">
        <div>广告合作客服邮箱：<a href="mailto:yt@zenmen.com">yt@zenmen.com</a></div>
        <div class="pip"></div>
        <!-- <div>广告合作客服QQ：3007314925</div>
        <div class="pip"></div> -->
        <div>广告合作客服电话：<a href="tel:13818759977">13818759977</a></div>
      </div>
      <div style="margin: 50px 0 0">
        <div v-if="copyright">&copy;2012-{{ currYear }} {{ copyright }}版权所有</div>
        <div class="m-t-1" v-if="icp">
          <a href="http://beian.miit.gov.cn/" target="_blank">{{ icp }}</a>
        </div>
        <a flex="cross:center main:center" class="m-t-1" target="_blank" :href="police.link" v-if="police">
          <img :src="iconPoliceBeian" />
          <span class="m-l-1">{{ police.label }}</span>
        </a>
      </div>
    </div>
  </div>
</template>
<script>
import iconPoliceBeian from '@/assets/police_beian.png';
export default {
  name: '',
  props: {},
  data() {
    const host = process.env.NODE_ENV === 'development' ? 'ad.wifi.com' : location.host;
    const isWifi = host === 'ad.wifi.com' || host === 'pre.ad.wifi.com';
    const isWkanx = host === 'wkanx.com' || host === 'www.wkanx.com';
    return {
      iconPoliceBeian,
      copyright: isWifi ? '南京尚网网络科技有限公司' : isWkanx ? '南京尚网网络科技有限公司' : '',
      icp: isWifi ? '苏ICP备19004211号' : isWkanx ? '苏ICP备19004211号-11' : '',
      police: isWifi
        ? {
            label: '苏公网安备 32010502010288号',
            link: 'http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=32010502010288',
          }
        : isWkanx
        ? null
        : null,
    };
  },
  computed: {
    currYear() {
      var year;
      try {
        year = new Date().getFullYear();
      } catch (error) {
        year = 2021;
      }
      return year;
    },
  },
  watch: {},
  methods: {},
  created() {},
  mounted() {},
};
</script>
<style lang="scss" scoped>
.footer {
  margin: 60px 0 0;
}
.pip {
  width: 1px;
  background: #565656;
  height: 10px;
}
</style>
